import {
  ChatMessageEntityLinkType,
  ChatThread,
} from '@texas/api/endpoints/chat/chatApi';
import { SignalDispatcher } from 'ste-signals';
import { SimpleEventDispatcher } from 'ste-simple-events';
import { CustomElement } from './extensions';
import { EntityItem } from './types';

export const aiEvents = {
  newThreadCreated: new SignalDispatcher(),
  newThreadCreatedWithPrompt: new SimpleEventDispatcher<ChatThread[]>(),
  messagePosted: new SignalDispatcher(),
  updateMessage: new SimpleEventDispatcher<CustomElement[]>(),
  appendEntity: new SimpleEventDispatcher<{
    item: EntityItem;
    type: ChatMessageEntityLinkType;
  }>(),
};
